import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { MotivoDepuracionService } from '../../../services/MotivoDepuracionService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'motivo_depuracion',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. DEP-01',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'motivo_depuracion_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Descripción del motivo',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const MotivoDepuracionForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await MotivoDepuracionService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await MotivoDepuracionService.guardar(values);
  };

  return (
    <CatalogForm
      title="Motivo de Depuración"
      subtitle="Causa o justificación para depuración de registros"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/MotivosDepuracion"
    />
  );
};

export default MotivoDepuracionForm;
